import { IVMData } from "./IGetUserContentResponse";

export function findQuestionIdByLabId(questions: IQuestion[]|null, labId: string): string|null {
    if (questions)
        for (const question of questions) {
            if (question.type === "lab" && question.lab_id === labId) {
                return question.id;
            }
        }
    return null;
}


export interface IAssessmentObject {
  cohort_id: string;
  cohort_code: string;
  lmodule_code: string;
  questions_id: string;
  vm: IVMData | null;
  key: string;
  title: string;
  multiple_lmodules?: boolean;
  lmodule_title?: string;
  hover?: string;
  anonymous: boolean;
  submitted: boolean;
  validfrom: string;
  validto: string;
  validin: number;
  enabled: boolean;
  disable_text?: string;
  can_start?: boolean;
  active?: boolean;
  shown?: boolean;
  started_at: number;
  fillout_time?: number;
  qualification: boolean;
  threshold_percentage?: number;
  qualified: boolean;
  qualification_certificate_link?: string;
  //
  email: string|null; // Used by anonymous assessments
  fullname: string|null; // Used by anonymous assessments
}

export interface IAssessments {
  [key: string]: IAssessmentObject;
}

export interface IQuestionAnswer {
  [key: string]: string|boolean|undefined; // QuestionKey: Answer
  correct?: string|boolean; // Correct answer (present only if submitted)
  reason?: string; // Reason for the answer (present only if submitted)
}

export interface IQuestion {
  id: string;
  answers: IQuestionAnswer[];
  text: string;
  text_additional: string;
  type: string;
  lab_id?: string;
}

export interface IAnswers {
  [key: string]: string|null|{}
}

export type IAssessmentResults = { [key: string]: string | number | boolean };

export interface IAnswersData {
  key: string;
  submitted: boolean;
  answers?: IAnswers;
  points?: number;
  max_points?: number;
  passed: boolean;
  passed_percentage?: number;
  can_restart_at: number;
  can_restart_at_text: string;
  results: { [key: string] : IAssessmentResults };
}

export interface IAssessmentResponse {
  status: string;
  key: string;
  assessment_obj: IAssessmentObject;
  questions?: IQuestion[];
  answers_data?: IAnswersData;
  reward_data?: {};
  message?: string
  qualification_certificate_link?: string;
}
